import { useDispatch, useSelector } from "react-redux";

import { RootState } from "redux/store";
import { DashboardTilesFilterModel } from "models/Dashboard/DashboardTilesFilterModel";
import { setSelectedDashboardFilter } from "redux/masterPageStateSlice";

export type DashboardFilterStateModel = {
	financialYearIds: string[];
	purchaseCategoryIds: string[];
	purchaseTypeIds: string[];
	transactionTypeIds: string[];
	departmentErpDbCompanyIds: string[];
	programmeIds: string[];
	erpDbCompanyIds: string[];
};

export const dashboardFilterStateInitialValue = {
	financialYearIds: [],
	purchaseCategoryIds: [],
	purchaseTypeIds: [],
	transactionTypeIds: [],
	departmentErpDbCompanyIds: [],
	programmeIds: [],
	erpDbCompanyIds: [],
};

const useDashboardFilter = () => {
	const dispatch = useDispatch();
	const selectedFilters: DashboardFilterStateModel = useSelector(
		(state: RootState) => state.masterPageState.dashboardFilterDetail
	);

	const setSelectedFilter = (filterModel: DashboardTilesFilterModel) => {
		dispatch(
			setSelectedDashboardFilter({
				purchaseTypeIds: filterModel.purchaseTypeIds,
				transactionTypeIds: filterModel.transactionTypeIds,
				financialYearIds: filterModel.financialYearId,
				purchaseCategoryIds: filterModel.purchaseCategoryIds,
				departmentErpDbCompanyIds: filterModel.departmentErpDbCompanyIds,
				programmeIds: filterModel.selectedProgrammeIds,
				erpDbCompanyIds: filterModel.erpDbCompanyId,
			})
		);
	};

	const resetSelectedFilter = () => {
		dispatch(setSelectedDashboardFilter(dashboardFilterStateInitialValue));
	};

	const hasSelectedFilter = () => {
		return (
			selectedFilters &&
			Object.values(selectedFilters).some((s) => s.length > 0)
		);
	};

	const financialYearIds =
		selectedFilters &&
		selectedFilters.financialYearIds &&
		typeof selectedFilters.financialYearIds === "number"
			? [(selectedFilters.financialYearIds as any).toString()]
			: [];

	const purchaseCategoryIds =
		selectedFilters && selectedFilters.purchaseCategoryIds.length > 0
			? selectedFilters.purchaseCategoryIds
			: [];

	const transactionTypeIds =
		selectedFilters && selectedFilters.transactionTypeIds.length > 0
			? selectedFilters.transactionTypeIds
			: [];

	const purchaseTypeIds =
		selectedFilters && selectedFilters.purchaseTypeIds.length > 0
			? selectedFilters.purchaseTypeIds
			: [];

	const departmentErpDbCompanyIds =
		selectedFilters && selectedFilters.departmentErpDbCompanyIds.length > 0
			? selectedFilters.departmentErpDbCompanyIds
			: [];

	const programmeIds =
		selectedFilters && selectedFilters.programmeIds.length > 0
			? selectedFilters.programmeIds
			: [];

	const erpDbCompanyIds =
		selectedFilters &&
		selectedFilters.erpDbCompanyIds &&
		typeof selectedFilters.erpDbCompanyIds === "number"
			? [(selectedFilters.erpDbCompanyIds as any).toString()]
			: [];

	return {
		financialYearIds,
		purchaseCategoryIds,
		purchaseTypeIds,
		transactionTypeIds,
		departmentErpDbCompanyIds,
		programmeIds,
		erpDbCompanyIds,
		setSelectedFilter,
		resetSelectedFilter,
		hasSelectedFilter,
	};
};

export default useDashboardFilter;
